import { styled } from '@mui/material';

export const StatName = styled('div')(() => ({
  textTransform: 'uppercase',
  fontSize: "38px"
}));
export const StatValue = styled('div')(() => ({

  fontSize: "38px"
}));
export const SelectContainer = styled('div')(() => ({
  marginBottom: 15,
  marginRight: 30,
  width: 294,
}));

export const ButtonsContainer = styled('div')(() => ({
  marginBottom: 15,
  paddingTop: 6,
  '& button:first-of-type': {
    marginRight: 5,
  },
}));
